import { computed, ref } from 'vue';

export const useTimer = (minutes = 3) => {
  const expiration = ref<Date | null>(null);

  const isExpired = computed(() => {
    const validator = new Date().getTime();
    if (!expiration.value) return true;
    return expiration.value.getTime() < validator;
  });

  const startTimer = () => {
    const _expiration = new Date();
    _expiration.setMinutes(_expiration.getMinutes() + minutes);
    expiration.value = _expiration;
  };

  const resetTimer = () => {
    expiration.value = null;
  };

  return { isExpired, startTimer, resetTimer };
};
